export default function(number, fixed) {
  try{
    return `R ${(number).toLocaleString("en-US", {minimumFractionDigits: fixed})}`;
  }catch(e){
    return 'R ' + number;
  }
  
}